module.exports = __webpack_public_path__ + "img/5.6ac4741e.png";